// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-header[data-v-f219aa5a]{height:40px;background-color:#df5813;color:#fff;line-height:40px;font-size:16px;width:100%;text-align:center}.edit-header .edit-header-icon[data-v-f219aa5a]{font-size:16px;width:40px;line-height:40px!important;position:absolute;cursor:pointer}.edit-header .edit-header-icon.icon-back[data-v-f219aa5a]{left:0}.edit-header .edit-header-icon.icon-close[data-v-f219aa5a]{right:0}", ""]);
// Exports
module.exports = exports;
